(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-the-clubs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-open-club-drawer]').forEach(el => el.addEventListener('click', function() {
    document.querySelector('[data-club-drawer]').setAttribute('open', '');
    document.querySelector('[data-overlay]').classList.add('active');
    const clubType = this.dataset.openClubDrawer;
    if (clubType) {
      const clubElement = document.querySelector(`[data-club-type="${clubType}"]`);
      if (clubElement) {
        document.querySelector('[data-club-drawer]').querySelector('.overflow-y-auto').scrollTo({
          top: clubElement.offsetTop - 76,
          behavior: 'smooth'
        });
      }
    }
  }));
  document.querySelector('[data-close-drawer="about-clubs"]').addEventListener('click', function() {
    document.querySelector('[data-club-drawer]').removeAttribute('open');
    document.querySelector('[data-overlay]').classList.remove('active');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["compare-sets"] && !Shopify.designMode) return;
  try {
    
  var slideUp = function(target, duration) {
    target.style.transitionProperty = 'height, margin, padding';
    target.style.transitionDuration = duration + 'ms';
    target.style.boxSizing = 'border-box';
    target.style.height = target.offsetHeight + 'px';
    target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    window.setTimeout(() => {
      target.style.display = 'none';
      target.style.removeProperty('height');
      target.style.removeProperty('padding-top');
      target.style.removeProperty('padding-bottom');
      target.style.removeProperty('margin-top');
      target.style.removeProperty('margin-bottom');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  var slideDown = function(target, duration) {
    target.style.removeProperty('display');
    var display = window.getComputedStyle(target).display;
    if (display === 'none') 
      display = 'block';
    



    target.style.display = display;
    var height = target.offsetHeight;
    target.style.overflow = 'hidden';
    target.style.height = 0;
    target.style.paddingTop = 0;
    target.style.paddingBottom = 0;
    target.style.marginTop = 0;
    target.style.marginBottom = 0;
    target.offsetHeight;
    target.style.boxSizing = 'border-box';
    target.style.transitionProperty = "height, margin, padding";
    target.style.transitionDuration = duration + 'ms';
    target.style.height = height + 'px';
    target.style.removeProperty('padding-top');
    target.style.removeProperty('padding-bottom');
    target.style.removeProperty('margin-top');
    target.style.removeProperty('margin-bottom');
    window.setTimeout(() => {
      target.style.removeProperty('height');
      target.style.removeProperty('overflow');
      target.style.removeProperty('transition-duration');
      target.style.removeProperty('transition-property');
    }, duration);
  }
  var slideToggle = function(target, duration) {
    if (window.getComputedStyle(target).display === 'none') {
      return slideDown(target, duration);
    } else {
      return slideUp(target, duration);
    }
  }
  document.querySelector('[data-toggle-compare]').addEventListener('click', function() {
    slideToggle(document.querySelector('[data-compare-table]'), 400);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["why-stix"] && !Shopify.designMode) return;
  try {
    
  document.querySelector('[data-open-learn-more-drawer]').addEventListener('click', function() {
    document.querySelector('[data-learn-more-drawer]').setAttribute('open', '');
    document.querySelector('[data-overlay]').classList.add('active');
  });
  document.querySelector('[data-close-drawer="why-stix"]').addEventListener('click', function() {
    document.querySelector('[data-learn-more-drawer]').removeAttribute('open');
    document.querySelector('[data-overlay]').classList.remove('active');
  });

  } catch(e) { console.error(e); }
})();
})();
